// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"ChildLocationsTable_cardFooter__1Wl5g","table":"ChildLocationsTable_table__Ri5TM","emptyMessageContainer":"ChildLocationsTable_emptyMessageContainer__1hgHr"};